import { render, staticRenderFns } from "./EnergyConsumptionPerSqm.vue?vue&type=template&id=9a454918&"
import script from "./EnergyConsumptionPerSqm.vue?vue&type=script&lang=ts&"
export * from "./EnergyConsumptionPerSqm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports